module.exports = __webpack_public_path__ + "static/media/chevron.b1943882.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chevron.svg
// module id = 120
// module chunks = 0